import { Injectable } from '@angular/core';
import { UserProfile } from '../api/resources/user-resources';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SettingsExtensions } from '../extensions/settings-extensions';

@Injectable()
export class SettingsService {

  public user: UserProfile = {};
  private app: any;
  private layout: any;

  public userUpdated = new Subject<UserProfile>();

  constructor() {
    // App Settings
    // -----------------------------------
    this.app = {
      showFilters: false,
      name: environment.ui.appName,
      description: environment.ui.appDescription,
      year: ((new Date()).getFullYear())
    };

    // Layout Settings
    // -----------------------------------
    this.layout = SettingsExtensions.defaultConfiguration();

  }

  public getAppSetting(name: string) {
    return name ? this.app[name] : this.app;
  }
  public getUserSetting(name?: string) : UserProfile | any{
    return name ? this.user[name] : this.user;
  }

  public getLayoutSetting(name: string) {
    return name ? this.layout[name] : this.layout;
  }

  public setAppSetting(name: string, value: any) {
    if (typeof this.app[name] !== 'undefined') {
      this.app[name] = value;
    }
  }
  public setUserSetting(name: string, value: any) {
    if (typeof this.user[name] !== 'undefined') {
      this.user[name] = value;
    }
  }
  public setUser(user: UserProfile) {

    this.user = user;

    this.userUpdated.next(this.user);
    /*
        setTimeout(() => {
          const ev: any = { groupId: EVENTS.ON_USER_CHANGED, payload: this.user, recipentIds: null };
          this.conn.post(ev);
        }, 0); */
  }

  public setLayoutSetting(name: string, value: any) {
    if (typeof this.layout[name] !== 'undefined') {
      return this.layout[name] = value;
    }
  }

  public toggleLayoutSetting(name: string) {
    return this.setLayoutSetting(name, !this.getLayoutSetting(name));
  }

}
